import React, { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import getSi from 'utils/getSi';
import updateHealthIssuesAnswers from 'utils/updateHealthIssuesAnswers';
import updateQuizInfo, { getQuizInfo } from 'utils/updateQuizInfo';
import DotDetails from '../DotDetails/DotDetails';
import getName from 'utils/getName';
import DotSelector from '../DotSelector/DotSelector';
import { useDispatch, useSelector } from 'react-redux';

import QuizSlideHeading from '../QuizSlideHeading/QuizSlideHeading';
import QuizSlideNavigation from '../QuizSlideNavigation/QuizSlideNavigation';

const QuizJointCareOne = () => {
  const navigate = useNavigate();
  const si = getSi();
  const [name, setName] = useState('');
  const contextName = useSelector((state) => state.quiz.name);
  const dispatch = useDispatch();

  useEffect(() => {
    const dogName = async () => {
      if (contextName) {
        setName(contextName);
      } else {
        const n = await getName(si, dispatch);
        setName(n);
      }
    };
    dogName();
  }, [si]);

  useEffect(() => {
    const info = getQuizInfo();
    if (info?.joint_q1) {
      setOption(info.joint_q1);
    }
  }, []);

  useEffect(() => {
    if (si) {
      updateQuizInfo({ slide: 'joint-care-1' });
      sessionStorage.setItem(
        'current_health_issue',
        JSON.stringify('joint-care'),
      );
    } 
  }, [si]);

  const [option, setOption] = useState(1);
  const dotSelectorData = [{ name: 1 }, { name: 2 }, { name: 3 }];
  const handleClick = () => {
    if (option) {
      updateQuizInfo({ joints_q1: option });
      updateHealthIssuesAnswers({ joints_q1: option });
      navigate(`/quiz/joint-care-2/?si=${si}`);
    }
  };

  const dotDetailsData = [
    {
      title: 'Not at all',
      body: 'My dog is always able to walk, run and jump and rarely shows stiffness',
    },
    {
      title: 'Somewhat',
      body: ' My dog generally walks more slowly than they used to and sometimes seems stiff',
    },
    {
      title: 'Significantly',
      body: 'My dog always walks slowly and and their movements appear noticeably stiff',
    },
  ];
  return (
    <section className="min-h-screen bg-dteal-50 pt-24 md:pt-4">
      <div className="px-9 container mx-auto flex h-screen flex-col items-center justify-center gap-9">
        <QuizSlideHeading
          before={`Does ${name}`}
          title="Walk slowly and/or stiffly?"
        />
        <div>
          <DotSelector
            data={dotSelectorData}
            option={option}
            setOption={setOption}
            details={dotDetailsData}
          />
          <DotDetails details={dotDetailsData} />
        </div>
        <QuizSlideNavigation handleBack={()=>navigate(-1)}   handleNext={handleClick} />
      </div>
    </section>
  );
};

export default QuizJointCareOne;
